<button (click)="back()">
    <span *ngIf="prevPage === 'pubSearch'">{{'common.backToSearchResult' | hisUi }}</span>
    <span *ngIf="prevPage === 'importCandidates'">{{'fs.res.publication.import.candidates.back' | hisUi }}</span>
</button>

<div class="layoutblock searchresultListContainer">
    <div class="searchresultListSideLeft">  
        <div class="circle-icon">
            <div>
                <img hisImage="publication_duplicate" class="inlineicon" [title]="'cs.sys.duplicates.check.potentialDuplicate' | hisUi">
            </div>          
        </div>
    </div>
	
    <div class="searchresultListpageCenter">
        <div class="vcardSearchresult">
            <ng-container *ngIf="mainRow">
                <h2>{{'cs.sys.duplicates.check.potentialDuplicate' | hisUi}}</h2>
                <div class="clearerSpaceAbove1Em"></div> 
                <res-publication-search-result-list-element
                    [pub]="mainRow"
                    [isDuplicate]="true"
                    [prevPage]="'duplicates'"
                    [disableActionButtons]="true"
                    (delete)="onDelete($event)">
                </res-publication-search-result-list-element>
            </ng-container>
        </div>
	</div>
	
	<div class="searchresultListpageRight">
	        <!--Platzhalter für leere rechte Spalte, wird ausgeblendet, wenn Breakpoint SMALL -->
	</div>
</div>
        <div class="clearerSpaceAbove1Em"></div>
        <div class="clearerSpaceAbove1Em"></div>

<div class="layoutblock searchresultListContainer similarPublicationsList">
    <div class="searchresultListSideLeft">  
        <div class="circle-icon">
            <div>
                <img hisImage="PUBLICATION" class="inlineicon" [title]="'fs.res.publication.Publication' | hisUi">
            </div>          
        </div>
    </div>
	
    <div class="searchresultListpageCenter">   
	    
	            <h2>{{'fs.res.publication.duplicates.similarPublications' | hisUi: data.length}}</h2>
	      
	            <div class="infoMessage" *ngIf="hisSearchResultComponent.resultRowsLimitedMessage">{{ hisSearchResultComponent.resultRowsLimitedMessage | hisUi : hisSearchResultComponent.maxResultRows }}</div>
	    
	            <!-- Layout SearchResultList Inhalt -->
	            <ul class="searchResultList">
	                <li *ngFor="let pub of data" class="resultListDetail">
	                    <res-publication-search-result-list-element
	                        [pub]="pub"
	                        [isDuplicate]="false"
	                        [disableActionButtons]="true"
	                        [prevPage]="'duplicates'"
	                        (delete)="onDelete($event)">
	                    </res-publication-search-result-list-element>
	                </li>
	            </ul>
	            
	            <!-- "no data message" für Duplikatsseite -->
	            <div *ngIf="data.length === 0">
	                <span>{{'fs.res.publication.duplicates.similarPublications.notFound' | hisUi}}</span>
	            </div>
	            
	            <div class="ui-paginator">
	                <p-paginator [first]="first" [rows]="rowsPerPage" [totalRecords]="totalRecords" (onPageChange)="paginate($event)"></p-paginator>
	            </div>
	            <p></p>
	        
	</div>
	
    <div class="searchresultListpageRight">
        <!--Platzhalter für leere rechte Spalte, wird ausgeblendet, wenn Breakpoint SMALL -->
    </div>
</div>
